export function getCardErrorMessage(errorCode, bankName, cardType) {
  const errors = {
    "-60":
      "Thank you for your interest. This promotion has reached its maximum usage limit !",
    "-61": "Please try with a different offer or payment mode.",
    "-62": "The offer is not valid for this transaction amount.",
    "-63": "The offer is not valid for this transaction amount.",
    "-64":
      "You are not eligible for this offer or you have already availed the offer.",
    "-65": "There was an error with your transaction. Please try again later.",
    "-66": "Please try with a different offer or payment mode.",
    "-221":
      "Something went wrong, please try again with a different payment mode.",
    "-228":
      "Something went wrong, please try again with a different payment mode.",
    "-232": "You are not eligible for this offer.",
    "-268": `Your ${
      bankName && bankName.toLowerCase()
    } bank card is presently not eligible for EMI. Please continue to quickly check your eligibility for a different tenure or card.  It won't even take a minute!`,
    "-286": `Your ${
      bankName && bankName.toLowerCase()
    } bank card is presently not eligible for EMI. Please continue to quickly check your eligibility for a different tenure or card.  It won't even take a minute!`,
    "-288": `Your ${
      bankName && bankName.toLowerCase()
    } bank card is presently not eligible for EMI. Please continue to quickly check your eligibility for a different tenure or card.  It won't even take a minute!`,
    "-289": "You are not eligible for this offer.",
    "-416": `Your ${bankName && bankName.toLowerCase()} bank ${
      cardType && cardType.toLowerCase()
    } card has already availed this offer. Please use different card to quickly check your eligibility`,
  };

  return (
    errors[errorCode] ||
    "Something went wrong, please try again with a different payment mode."
  );
}

export function ConvertValueToPercent(iPercentValue) {
  const iQuotient = Math.floor(iPercentValue / 10000);
  let strRemainder = (iPercentValue % 10000).toString().padStart(4, "0");
  strRemainder = strRemainder.substring(0, 2);
  const strPercent = strRemainder === "00" ? iQuotient.toString() : iQuotient.toString() + "." + strRemainder;
  return strPercent;
}

function formatNumberIndianSystem(number) {
  var numStr = number.toString();
  var [integerPart, decimalPart] = numStr.split(".");
  var reverseIntegerPart = integerPart.split("").reverse().join("");
  var indianFormatted = reverseIntegerPart
    .replace(/(\d{3})(?=\d)/g, "$1,")
    .replace(/(\d{2})(?=\d{2},)/g, "$1,");
  indianFormatted = indianFormatted.split("").reverse().join("");
  if (decimalPart) {
    indianFormatted += "." + decimalPart;
  }
  return indianFormatted;
}

export function formatNumber(value = 0) {
  if(!isNaN(value)){
    return formatNumberIndianSystem(value.toFixed(2));
  } else {
    return value;
  }
}

export function sortTenures(tenures) {
  return tenures?.slice().sort((a, b) => a.tenure_in_month - b.tenure_in_month);
};

export const EncryptUsingAes = (Data, RandomKey) => {
  let CryptoJS1 = window.CryptoJS;
  RandomKey = RandomKey.toString();

  var key = window.CryptoJS.enc.Utf8.parse(RandomKey);
  var iv = key;

  var encryptedData = CryptoJS1.AES.encrypt(
    CryptoJS1.enc.Utf8.parse(Data),
    key,
    {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS1.mode.CBC,
      padding: CryptoJS1.pad.Pkcs7,
    }
  );
  return encryptedData;
};
